<template>
  <div class="container-fluid">
    <div class="row listBar">
      <div class="col">
        <div class="Orders">訂單記錄（最近十筆）</div><div class="Arrangement">時間排序</div>
      </div>
    </div>
    <div class="row Orders" v-for="(Order, index) in Orders" :key="(Order, index)" @click="goOrder(Order.id)">
      <hr>
      <div class="col TimeName" :class="{ 'orderAccept': Order.shopReply == '接受' && Order.mealDoneTime != null, 'orderRefuse': Order.shopReply == '拒絕' }">
        <div>{{Order?.Time.substring(0, 16)}}</div>
        <div>{{Order?.shopName}}</div>
      </div>
      <div class="col StatusPrice" :class="{ 'orderAccept': Order.shopReply == '接受' && Order.mealDoneTime != null, 'orderRefuse': Order.shopReply == '拒絕' }">
        <div v-if="Order.shopReply == '接受' && Order.mealDoneTime != null">（已出餐）</div>
        <div v-else-if="Order.shopReply == '拒絕'">（未成交）</div>
        <div v-else>（備餐中）</div>
        <div v-if="!Order.discountPrice" class="Price">${{Order?.Price}}</div>
        <div v-else class="Price">${{Order?.discountPrice}}</div>
      </div>
    </div>
    <div class="row FooterSpace"></div>
    <div class="row Footer">
      <div class="col">
        <button class="btn" @click="Home()">
          <i class="fas fa-home"></i><br><span>首頁</span>
        </button>
      </div>
      <div class="col">
        <button class="btn" @click="User()">
          <i class="fa-solid fa-user"></i><br><span>會員</span>
        </button>
      </div>
      <div class="col">
        <button class="btn" @click="Advertises()">
          <i class="fa-solid fa-rectangle-ad"></i><br><span>好康</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Global } from '@/Service/GlobalService'

import { getUserOrdersByLatestTen, getUserOrdersByLatestTenByGuest } from '@/Service/APIService'

const GUEST_ORDER_DAYS = 30
const GUEST_ORDER_STORAGE_KEY = 'guestOrders'

export default {
  name: "Orders",
  data() {
    return {
      Orders: [], // 最近十筆訂單
      orderStatusChannel: null // Socket 訂閱頻道，用於即時收到店家完成/拒絕
    }
  },
  methods: {
    /* 從 localStorage 讀取遊客訂單，只保留 30 天內，並回寫以刪除過期 */
    getGuestOrdersFromStorage: function() {
      const raw = JSON.parse(localStorage.getItem(GUEST_ORDER_STORAGE_KEY) || '[]')
      const cutoff = new Date()
      cutoff.setDate(cutoff.getDate() - GUEST_ORDER_DAYS)
      const filtered = raw.filter(o => new Date(o.Time) >= cutoff)
      localStorage.setItem(GUEST_ORDER_STORAGE_KEY, JSON.stringify(filtered))
      return filtered
    },
    /* 僅遊客使用：將訂單列表寫入 localStorage（已過濾 30 天內） */
    saveGuestOrdersToStorage: function(orders) {
      const cutoff = new Date()
      cutoff.setDate(cutoff.getDate() - GUEST_ORDER_DAYS)
      const within = (orders || []).filter(o => new Date(o.Time) >= cutoff)
      localStorage.setItem(GUEST_ORDER_STORAGE_KEY, JSON.stringify(within))
    },
    /* 初始化：會員只從 API；遊客從 API + localStorage（僅 30 天）；未登入只顯示 localStorage 遊客訂單 */
    init: async function() {
      if (!Global.User) {
        this.$data.Orders = this.getGuestOrdersFromStorage()
        return
      }
      if (!Global.isGuest) {
        await this.getOrders()
        this.subscribeOrderStatus()
        return
      }
      await this.getOrders()
      const fromStorage = this.getGuestOrdersFromStorage()
      const merged = [...this.$data.Orders]
      fromStorage.forEach(o => {
        if (!merged.some(m => m.id == o.id)) merged.push(o)
      })
      merged.sort((a, b) => (b.id - a.id) || (new Date(b.Time) - new Date(a.Time)))
      const cutoff = new Date()
      cutoff.setDate(cutoff.getDate() - GUEST_ORDER_DAYS)
      this.$data.Orders = merged.filter(o => new Date(o.Time) >= cutoff)
      this.saveGuestOrdersToStorage(this.$data.Orders)
      this.subscribeOrderStatus()
    },
    /* App 還原登入狀態（會員或遊客）後重新初始化（支援 F5 之後的遊客訂單監聽） */
    handleUserLoginChanged: function() {
      this.init()
    },
    /* 訂閱消費者訂單狀態頻道（會員/遊客各一），收到 Finish/Delete 即時更新列表 */
    subscribeOrderStatus: function() {
      if (!window.Echo || !Global.User?.id) return
      const channelName = Global.isGuest
        ? 'GuestOrderStatusChannel.' + Global.User.id
        : 'UserOrderStatusChannel.' + Global.User.id
      if (this.$data.orderStatusChannel) {
        window.Echo.leave(channelName)
      }
      this.$data.orderStatusChannel = window.Echo.channel(channelName)
      this.$data.orderStatusChannel.listen('.ConsumerOrderStatusEvent', (e) => {
        const orderId = e?.orderId
        const status = e?.orderStatus
        if (!orderId || !status) return
        const list = this.$data.Orders
        const idx = list.findIndex(o => o.id == orderId)
        if (idx === -1) return
        if (status === 'Finish') {
          list[idx].mealDoneTime = new Date().toISOString().slice(0, 19).replace('T', ' ')
        } else if (status === 'Delete') {
          list[idx].shopReply = '拒絕'
        }
        if (Global.isGuest) this.saveGuestOrdersToStorage(this.$data.Orders)
        this.$forceUpdate()
      })
    },
    getOrders: async function() {
      if (Global.isGuest) {
        const response = await getUserOrdersByLatestTenByGuest(Global.User.id)
        this.$data.Orders = response.data || []
      } else {
        const response = await getUserOrdersByLatestTen()
        this.$data.Orders = response.data || []
      }
    },
    /* 前往訂單資訊頁面 */
    goOrder: function(id) {
      this.$router.push({ path: `/Order/${id}` })
    },
    /* 前往首頁頁面 */
    Home: function() {
      this.$router.push({ name: `Home` })
    },
    /* 前往會員資料頁面 */
    User: function() {
      this.$router.push({ name: `User` })
    },
    /* 前往好康頁面 */
    Advertises: function() {
      this.$router.push({ name: `Advertises` })
    },
  },
  mounted() {
    this.init()
    Global.on(Global.EVENT.CHECK_USER_LOGIN, this.handleUserLoginChanged)
  },
  unmounted() {
    Global.off && Global.off(Global.EVENT.CHECK_USER_LOGIN, this.handleUserLoginChanged)
    if (this.$data.orderStatusChannel && Global.User?.id) {
      const channelName = Global.isGuest
        ? 'GuestOrderStatusChannel.' + Global.User.id
        : 'UserOrderStatusChannel.' + Global.User.id
      window.Echo?.leave(channelName)
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid, .row {
  margin: 0px;
  padding: 0px;
  > .listBar {
    margin: 0px;
    padding: 10px 0px;
    background-color: #87CEFAAA;
    color: #000000;
    text-shadow: 1px 1px 0 #FFFFFF;
    font-size: 18px;
    font-weight: 900;
    > .col {
      > .Orders {
        float: left;
        padding-left: 15px;
      }
      > .Arrangement {
        float: right;
        padding-right: 15px;
        > .Arrow {
          margin-left: 10px;
        }
      }
    }
  }
  > .Orders {
    margin-bottom: 10px;
    font-weight: bold;
    > .TimeName {
      padding-left: 25px;
    }
    > .StatusPrice {
      text-align:right;
      padding-right: 15px;
      .Price {
        padding-right: 10px;
      }
    }
    > .orderAccept {
      color: blue;
    }
    > .orderRefuse {
      color: red;
    }
  }
  > .FooterSpace {
    height: 70px;
  }
  > .Footer {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    height: 70px;
    background-color: #5599FF;
    > .col {
      > .btn {
        border: 0px;
        background-color: #5599FF;
        box-shadow: 0px 0px 0px 0px;
        color: #FFFFFF;
        font-size: 20px;
        font-weight: 900;
        > .fas {
          margin-bottom: 3px;
          font-size: 24px;
        }
      }
    }
  }
}

</style>